
import { Vue, Component } from 'vue-property-decorator';
import { getList } from '../api';
import { List } from 'vant';
Vue.use(List);

@Component
export default class Home extends Vue {
  id: number = 1;
  list: any[] = [];
  page = 1;
  loading = false;
  finished = false;

  show: boolean = true;

  onLoad() {
    getList(this.page).then((res: any) => {
      this.endListData(res);
    });
  }
  onJumpToOutside() {
        location.href = 'https://activity.cqcb.com/shangyou_activity/2022h1/2022-lianghui-h5/home';
  }
  endListData(res: any) {
    this.page = this.page + 1;
    this.finished = true;
    if (!res.data || res.data.length === 0) {
      this.finished = true;
    } else {
      this.list = [...this.list, ...res.data];
    }
    this.loading = false;
  }
  reset() {
    this.list = [];
    this.page = 1;
    this.loading = false;
    this.finished = false;
    this.show = false;
    setTimeout(() => {
      this.show = true;
    }, 50);
  }
}
